import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Head from 'next/head';
import get from 'lodash.get';

import { formatVertical } from 'lib/ampUtils';
import { shouldRenderRegularBlog } from 'lib/liveBlog';
import { isMain } from 'lib/vertical';

const mapStateToProps = ({ router, shared }) => ({
  domain: router.domain,
  vertical: shared.vertical,
});

export const buildAMPHTMLLink = ({ content, domain, vertical }, { isLiveBlog }) => {
  const id = get(content, 'id', null);

  // Return null if content ID does not start with n, t, r or m
  // (like - ncna##, tdna##, rcna##, mmvo##)

  if (!domain || !vertical || !id || !/^[ntrm]/.test(id)) {
    return null;
  }

  // handles video page routing for msnbc, news, and today
  let amp = 'amp';
  if (content.type === 'video') {
    if (isMain(vertical)) {
      amp = 'amp-video';
    } else {
      return null;
    }
  }

  const nativeAd = get(content, 'nativeAd', false);
  const presentationStyle = get(content, 'presentation.style', null);

  if (nativeAd || presentationStyle === 'shell') {
    return null;
  }

  let sub = '';
  if (isLiveBlog) {
    const subType = get(content, 'subType', null);
    sub = shouldRenderRegularBlog(subType) ? 'blog/' : 'live-blog/';
  }
  return `https://www.${domain}/${formatVertical(vertical)}/${amp}/${sub}${id}`;
};

const AMPHTMLLink = ({ content, domain, vertical }, { isLiveBlog }) => {
  const link = buildAMPHTMLLink({ content, domain, vertical }, { isLiveBlog });
  return (
    <Head>
      <link
        rel="amphtml"
        href={link}
      />
    </Head>
  );
};

AMPHTMLLink.propTypes = {
  content: PropTypes.shape({ }).isRequired,
  domain: PropTypes.string.isRequired,
  vertical: PropTypes.string.isRequired,
};

AMPHTMLLink.contextTypes = {
  isLiveBlog: PropTypes.bool,
};

export default connect(mapStateToProps)(AMPHTMLLink);
